import './styles/styles.css'
import './styles/print.css'
import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'

// import certImg from "../../images/tgifridays_cert_image.png";
import Customer from './images/Customer.png'
import Care from './images/Care.png'
import Listen from './images/Listen.png'
import Team from './images/Team.png'
// import OwnerShip from "./images/OwnerShip.png";
// import OwnerShip from "./images/OwnerShip.png";
import Momentum from './images/Momentum.png'
import Baner from './images/Baner.png'
import KiwiLogo from './images/KiwiLogo.png'
import CiseLogo from './images/CiseLogo.png'
import KitopiLogo from './images/KitopiLogo.png'
import TazikisLogo from './images/TazikisLogo.png'
import TgiLogo from './images/TgiLogo.png'
import JuicebarLogo from './images/JuicebarLogo.png'
import ImageCertificate from './images/ImageCertificate.png'
import ImageCertificate2 from './images/ImageCertificate2.png'
import boldFont from 'assets/fonts/OpenSans-Bold.ttf'
import lightItalicFont from 'assets/fonts/OpenSans-LightItalic.ttf'
import semiBoldItalicFont from 'assets/fonts/OpenSans-SemiBoldItalic.ttf'
import config from 'config'

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  Image,
  BlobProvider,
  Font,
} from '@react-pdf/renderer'
import { faFilePdf, faPrint } from '@fortawesome/free-solid-svg-icons'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { useDispatch } from 'react-redux'
import { setHideCertificate } from 'store/Course/actions'
import { useSelector } from 'react-redux'
import jsPDF from 'jspdf'
// Font.register(
// 	'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
// 	{ family: 'Oswald' }
// )

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
})

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: boldFont, fontWeight: 800 },
    { src: semiBoldItalicFont, fontWeight: 600 },
    { src: lightItalicFont, fontWeight: 300 },
  ],
})
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
  },
  section: {
    margin: 10,
    padding: 6,
    flexGrow: 1,
    borderWidth: 3,
    borderColor: 'gray',
  },
  inner: {
    paddingTop: 50,
    paddingBottom: 20,
    flexGrow: 1,
    borderWidth: 3,
    borderColor: 'gray',
    textAlign: 'center',
  },
  logo: {
    width: 100,
    height: 100,
    marginBottom: 30,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  defaultText: {
    fontSize: 20,
    marginBottom: 30,
    fontFamily: 'Times-Italic',
  },
  person: {
    fontSize: 45,
    fontFamily: 'Oswald',
    textDecoration: 'underline',
    marginBottom: 30,
  },
  course: {
    fontSize: 30,
    marginBottom: 20,
  },
  issuedBy: {
    fontSize: 17,
    fontFamily: 'Times-Italic',
  },
  issuedDate: {
    fontSize: 17,
    textAlign: 'left',
    marginTop: 80,
    paddingLeft: 20,
  },
})

const PrintCertificate = (props) => (
  <>
    <Document>
      <Page bsSize='A4' orientation='portrait' style={styles.page}>
        <View style={styles.section}>
          <View style={styles.inner}>
            <Image style={styles.logo} src={getLogo()} />
            <Text style={styles.defaultText}>
              This certificate is awarded to
            </Text>
            <Text
              style={styles.person}
            >{`${props.employee.first_name} ${props.employee.last_name}`}</Text>
            <Text style={styles.defaultText}>
              for the successful completion of the course
            </Text>
            <Text style={styles.course}>{props.course.name}</Text>
            {/* <Text style={styles.issuedBy}>By {`${process.env.CLIENT_ID}`}</Text> */}
            {props.course.certifyTime ? (
              <Text style={styles.issuedDate}>
                Completion date:{' '}
                {moment(props.course.certifyTime).format('MM/DD/YYYY')}
              </Text>
            ) : null}
          </View>
        </View>
      </Page>
    </Document>
  </>
)

// const PrintCertificate = (props) => (
//   <Document>
//     <Page bsSize='A4' orientation='landscape' style={styles.page}>
//       <View style={styles.section}>
//         <View style={styles.inner}>
//           <Text style={styles.course}>Completion date:</Text>
//         </View>
//       </View>
//     </Page>
//   </Document>
// )

const styles2 = StyleSheet.create({
  body: {
    paddingTop: 31,
    paddingBottom: 33,
    paddingHorizontal: 20,
  },
  section: {
    flexGrow: 1,
    borderWidth: 1,
    borderColor: '#c7e7f1',
    marginBottom: 7,
  },
  logo: {
    width: 130,
    margin: 'auto',
    padding: 4,
  },
  square: {
    width: 132,
    height: 142,
    marginLeft: -4,
    marginTop: -4,
  },
  baner: {
    width: 542,
  },
  textDiv: {
    width: 540,
    height: 'auto',
  },
  imagesCert: {
    width: 266,
    marginLeft: -6,
    marginBottom: -5,
    marginTop: -5,
  },
  flexDiv: {
    display: 'flex',
    flexDirection: 'row',
  },
  certTitle: {
    textAlign: 'center',
    fontSize: 11,
    textTransform: 'uppercase',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    marginTop: 100,
  },
  userName: {
    textAlign: 'center',
    fontSize: 20,
    color: '#5bc0de',
    textTransform: 'uppercase',
    marginTop: 25,
    fontFamily: 'Open Sans',
    fontWeight: 800,
  },
  completionSuccess: {
    textAlign: 'center',
    fontSize: 11,
    textTransform: 'uppercase',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    marginTop: 25,
    paddingRight: 150,
    paddingLeft: 150,
  },
  courseName: {
    textAlign: 'center',
    fontSize: 20,
    color: '#5bc0de',
    textTransform: 'uppercase',
    marginTop: 25,
    fontFamily: 'Open Sans',
    fontWeight: 800,
    paddingRight: 120,
    paddingLeft: 120,
  },
  completionDate: {
    textAlign: 'right',
    fontFamily: 'Open Sans',
    fontWeight: 300,
    fontSize: 10,
    position: 'relative',
    right: 10,
    top: 60,
  },
})
const getLogo = () => {
  if (window?.location?.hostname?.startsWith('kitopi')) return KitopiLogo
  else if (window?.location?.hostname?.startsWith('tazikis')) return TazikisLogo
  else if (window?.location?.hostname?.startsWith('tgifridays')) return TgiLogo
  else if (window?.location?.hostname?.startsWith('ilovejuicebar'))
    return JuicebarLogo
  else if (window?.location?.hostname?.startsWith('cise')) return CiseLogo
  else return KiwiLogo
}

const PrintCertificate2 = (props) => {
  function returnSrc() {
    const path =
      'https://www.compareanimal.com/wp-content/uploads/2014/07/elephant-fight-far.jpg'
    const selectedMethod = 'GET'
    return { uri: path, method: selectedMethod, body: '', headers: '' }
  }

  return (
    <Document>
      <Page bsSize='A4' orientation='landscape' style={styles2.body}>
        <View style={styles2.section}>
          <View style={styles2.flexDiv}>
            <View style={styles2.logo}>
              <Image src={getLogo(window.location.hostname)} />
            </View>
            <View style={styles2.square}>
              <Image src={ImageCertificate2} />
            </View>
            <View style={styles2.baner}>
              <Image src={Baner} />
            </View>
          </View>
          <View style={styles2.flexDiv}>
            <View style={styles2.imagesCert}>
              <Image src={ImageCertificate} />
            </View>
            <View style={styles2.textDiv}>
              <Text style={styles2.certTitle}>
                THIS CERTIFICATE IS AWARDED TO
              </Text>
              <Text style={styles2.userName}>
                {props.employee.first_name} {props.employee.last_name}
              </Text>
              <Text style={styles2.completionSuccess}>
                FOR THE SUCCESSFUL COMPLETION OF THE COURSE
              </Text>
              <Text style={styles2.courseName}>{props.course.name}</Text>
              <Text style={styles2.completionDate}>
                Completion date:{' '}
                {moment(props.course.certifyTime).format('DD/MM/YYYY')}{' '}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  )
}

const isHtmlContentEmpty = (html) =>
  !html || !html.replace(/<[^>]*>/g, '').trim().length

const CertificateTemplate1 = (props) => {
  const { certificateFooterContent: generalFooterContent, certificateFooter } =
    useSelector((store) => store.generalConfig)
  const courseFooterContent = props.course?.certificate_footer_content
  const certificateFooterContent = isHtmlContentEmpty(courseFooterContent)
    ? generalFooterContent
    : courseFooterContent
  useEffect(() => {
    props.onLoad()
  }, [])

  return (
    <div className='cert-temp-1'>
      <div
        style={{
          textAlign: 'center',
          border: '3px solid gray',
          padding: '50px 0',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img title={`${config.id} logo`} src={props?.navLogo?.url} />
        </div>
        <h5
          style={{
            fontFamily: 'Times-Italic',
            fontStyle: 'italic',
            fontSize: '20px',
            fontWeight: 'normal',
            marginBottom: '20px',
          }}
        >
          This certificate is awarded to
        </h5>
        <h1
          style={{
            fontFamily: 'Oswald',
            fontSize: '45px',
            fontWeight: 'normal',
            textDecoration: 'underline',
            marginBottom: '30px',
          }}
        >{`${props.employee.first_name} ${props.employee.last_name}`}</h1>
        <h5
          style={{
            fontFamily: 'Times-Italic',
            fontStyle: 'italic',
            fontSize: '20px',
            fontWeight: 'normal',
            marginBottom: '30px',
          }}
        >
          for the successful completion of the course
        </h5>
        <h3
          style={{
            fontSize: '30px',
            fontWeight: 'normal',
            marginBottom: '30px',
          }}
        >
          {props.course.name}
        </h3>
        {/* <h4 style={{fontSize: '17px', fontStyle: 'italic', fontWeight: 'normal'}}>By {`${process.env.CLIENT_ID}`}</h4> */}
        {certificateFooter ? (
          <div
            className='cert-footer-content'
            dangerouslySetInnerHTML={{ __html: certificateFooterContent }}
          ></div>
        ) : null}
        {props.course.certifyTime ? (
          <div
            style={{
              marginTop: !certificateFooter ? '100px' : '50px',
              textAlign: 'center',
              padding: '0 0 0 15px',
            }}
          >
            <p style={{ fontSize: '17px' }}>
              Completion date:{' '}
              {moment(props.course.certifyTime).format('MM/DD/YYYY')}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  )
}

const CertificateTemplate2 = (props) => {
  return (
    <div
      className='certificate-container'
      style={{ border: 'solid 1px #c7e7f1' }}
    >
      <div className='row'>
        <div className='col-' style={{ display: 'flex', padding: '0' }}>
          <div className='image-div' style={{ borderBottom: 'none' }}>
            <img
              title={`${config.id} logo`}
              src={props.navLogo.url}
              width='100%'
              alt='nav-logo'
            />
          </div>
          <div style={{ width: '50%', display: 'flex' }}>
            <div style={{ borderRight: 'solid 1px #c7e7f1', width: '50%' }}>
              <div
                style={{
                  borderBottom: 'solid 1px #c7e7f1',
                  height: '50%',
                  display: 'flex',
                }}
              ></div>
            </div>
            <div style={{ borderRight: 'solid 1px #c7e7f1', width: '50%' }}>
              <div
                style={{
                  borderBottom: 'solid 1px #c7e7f1',
                  height: '50%',
                  display: 'flex',
                }}
              ></div>
            </div>
          </div>
        </div>
        <div className='col-8' style={{ padding: '0' }}>
          <div className='baner'>
            {' '}
            <img src={Baner} />{' '}
          </div>
          {/* <div className='certificate-baner'>
          <h1>CONGRATULATIONS</h1>
        </div> */}
        </div>
      </div>
      <div className='row'>
        <div className='col-4' style={{ padding: '0' }}>
          <div className='image-div' style={{ borderTop: 'solid 1px #c7e7f1' }}>
            <img src={Customer} width='100%' />
          </div>
          <div className='image-div' style={{ borderTop: 'solid 1px #c7e7f1' }}>
            <img src={Care} width='100%' />
          </div>
          <div className='image-div'>
            <img src={Listen} width='100%' />
          </div>
          <div className='image-div'>
            <img src={Team} width='100%' />
          </div>
          <div className='image-div' style={{ borderBottom: 'none' }}>
            {/* <img src={OwnerShip} width="100%" /> */}
          </div>
          <div className='image-div' style={{ borderBottom: 'none' }}>
            <img src={Momentum} width='100%' />
          </div>
        </div>
        <div className='col-8 certificate-content'>
          <div className='certificate-headings'>
            <h3>THIS CERTIFICATE IS AWARDED TO</h3>
            <h1>
              {props.employee.first_name} {props.employee.last_name}
            </h1>
            <h3 style={{ marginTop: '30px' }}>
              FOR THE SUCCESSFUL COMPLETION OF THE COURSE
            </h3>
            <h1>{props.course.name}</h1>
          </div>
          <span>
            Completion date:{' '}
            {moment(props.course.certifyTime).format('DD/MM/YYYY')}{' '}
          </span>
        </div>
      </div>
    </div>
  )
}

const CertificateContent = (props) => {
  const { certificateFooterContent: generalFooterContent, certificateFooter } =
    useSelector((store) => store.generalConfig)
  const courseFooterContent = props.course?.certificate_footer_content
  const certificateFooterContent = isHtmlContentEmpty(courseFooterContent)
    ? generalFooterContent
    : courseFooterContent

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const [pdfLoaded, setPdfLoaded] = useState(false)

  const handlePdfLoad = () => {
    setPdfLoaded(true)
  }

  // Function to generate PDF using jsPDF
  const generatePdf = () => {
    const doc = new jsPDF()

    // Get logo image
    const logo = getLogo() // Assume getLogo() returns the image URL or base64 data

    // Page dimensions
    const pageWidth = doc.internal.pageSize.width
    const pageHeight = doc.internal.pageSize.height

    // Margins
    const outerMargin = 10 // Outer frame margin
    const borderGap = 5 // Reduce the gap between borders
    const innerMargin = outerMargin + borderGap // Adjust inner margin

    // Logo
    const logoWidth = 60
    const logoHeight = 60
    const logoX = (pageWidth - logoWidth) / 2
    doc.addImage(logo, 'PNG', logoX, outerMargin + 10, logoWidth, logoHeight)

    // Title Positioning
    const titleY = outerMargin + 80

    // Awarded To
    doc.setFont('times', 'italic')
    doc.setFontSize(16)
    doc.setTextColor('#32325d') // Dark Blue
    const awardedY = titleY + 20
    doc.text('This certificate is awarded to', pageWidth / 2, awardedY, {
      align: 'center',
    })

    // Employee Name (Prevent Overflow)
    doc.setFontSize(36)
    doc.setFont('oswald', 'bold')
    doc.setTextColor('#32325d') // Dark Blue
    const nameY = awardedY + 15
    const employeeName = `${props.employee.first_name} ${props.employee.last_name}`
    const maxTextWidth = pageWidth - 2 * innerMargin - 20 // Prevents overflow
    const wrappedName = doc.splitTextToSize(employeeName, maxTextWidth)
    console.log(maxTextWidth, wrappedName, 'leart610')

    doc.text(wrappedName, pageWidth / 2, nameY, { align: 'center' })

    // Course Completion Text
    doc.setFontSize(16)
    doc.setFont('times', 'italic')
    doc.setTextColor('#32325d') // Dark Blue
    const courseY = nameY + 30
    doc.text(
      'for the successful completion of the course',
      pageWidth / 2,
      courseY,
      { align: 'center' }
    )

    // Course Name (Prevent Overflow)
    doc.setFontSize(30)
    doc.setFont('oswald')
    doc.setTextColor('#32325d') // Dark Blue
    const wrappedCourseName = doc.splitTextToSize(
      props.course.name,
      maxTextWidth
    )
    console.log(
      wrappedCourseName,
      pageWidth,
      courseY + 15,
      maxTextWidth,
      'leart549'
    )
    doc.text(wrappedCourseName, pageWidth / 2, courseY + 15, {
      align: 'center',
    })

    let footerY = courseY + 50
    if (certificateFooter) {
      const rawFooterContent = certificateFooterContent || ''

      const plainFooterContent = rawFooterContent
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>\s*<p>/gi, '\n')
        .replace(/<\/?[^>]+(>|$)/g, '')

      if (plainFooterContent.trim()) {
        doc.setFontSize(14)
        doc.setFont('times', 'italic')
        doc.setTextColor('#6c757d') //
        const wrappedFooterContent = doc.splitTextToSize(
          plainFooterContent,
          maxTextWidth
        )
        doc.text(wrappedFooterContent, pageWidth / 2, footerY, {
          align: 'center',
        })
        footerY += 20
      }
    }

    // Completion Date
    if (props.course.certifyTime) {
      doc.setFontSize(14)
      doc.setFont('times', 'italic')
      doc.setTextColor('#a2a5b9') // Grayish Blue
      const completionDateY = pageHeight - outerMargin - 50
      doc.text(
        `Completion Date: ${moment(props.course.certifyTime).format(
          'MMMM DD, YYYY'
        )}`,
        pageWidth / 2,
        completionDateY,
        { align: 'center' }
      )
    }

    // Draw Double Border (Frame) in Gray
    doc.setDrawColor(150) // Gray color
    doc.setLineWidth(1)
    doc.rect(
      outerMargin,
      outerMargin,
      pageWidth - 2 * outerMargin,
      pageHeight - 2 * outerMargin
    ) // Outer border

    doc.setLineWidth(1)
    doc.rect(
      innerMargin,
      innerMargin,
      pageWidth - 2 * innerMargin,
      pageHeight - 2 * innerMargin
    ) // Inner border

    // Save PDF
    doc.save('certificate.pdf')
  }

  return (
    <div>
      <div className='row'>
        <div className='col-12'>
          <div className='quiz-row-wrapper'>
            {props.certificateType === 2 ? (
              <CertificateTemplate2 {...props} onLoad={handlePdfLoad} />
            ) : (
              <CertificateTemplate1 {...props} onLoad={handlePdfLoad} />
            )}
            <div id='print-certificate' className='cert-btn_container'>
              <button
                onClick={() => window.print()}
                className='btn btn-info cert-btn'
                style={{ marginRight: '10px' }}
              >
                <FontAwesomeIcon icon={faPrint} className='cert-icon mr-1' />
                {language.courses ? language.courses.print_certificate : null}
              </button>
              {pdfLoaded && (
                <button onClick={generatePdf} className='btn btn-info cert-btn'>
                  <FontAwesomeIcon
                    icon={faFilePdf}
                    className='cert-icon mr-1'
                  />
                  Save certificate to pdf
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Certificate = (props) => {
  const dispatch = useDispatch()
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  useEffect(() => {
    if (props.setBlink) {
      props.setBlink(false)
    }

    return () => {
      props.setBlink(true)
    }
  }, [props])

  const toggle = () => dispatch(setHideCertificate())
  return (
    <Modal
      isOpen={props.certificateShowing}
      toggle={toggle}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={toggle}>
        {language.courses ? language.courses.certificate : null}
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <CertificateContent {...props} />
      </ModalBody>
    </Modal>
  )
}

export default Certificate
